import { EnvelopeIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

import { Button, Paragraph } from "@fronterahealth/frontera-ui-components";

export const VerificationPending: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col w-full items-center my-4 md:my-8">
      <div className="flex flex-col gap-4 w-full max-w-2xl px-4 sm:px-6">
        <div className="flex flex-col items-center">
          <Paragraph className="text-xl! md:text-2xl!" size="large" colorType="primary" displayType="loud">
            Verification request received
          </Paragraph>
          <Paragraph size="medium">We'll reach out shortly to verify your ownership</Paragraph>
        </div>

        <div className="flex flex-col gap-6 p-8 rounded-lg border bg-white">
          <div className="flex flex-row gap-2 items-start rounded-lg p-4 bg-yellow-50 wrap-break-word">
            <InformationCircleIcon className="size-6 shrink-0 text-yellow-800" />
            <div className="w-full text-left">
              <Paragraph className="text-yellow-800!">
                <span className="font-semibold">Pending verification:</span> Your verification request has been
                submitted. Our team will contact you within 1 business day to gather proof of ownership and complete the
                verification process.
              </Paragraph>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <Paragraph className="text-lg!" colorType="primary" displayType="loud">
              What happens next?
            </Paragraph>

            <div className="flex flex-row gap-4">
              <div className="flex h-7 w-7 items-center justify-center rounded-full bg-text-primary text-white">1</div>
              <div className="flex flex-col">
                <Paragraph displayType="loud" colorType="primary">
                  We'll reach out to you
                </Paragraph>
                <Paragraph colorType="primary">Our team will contact you to gather proof of clinic ownership</Paragraph>
              </div>
            </div>

            <div className="flex flex-row gap-4">
              <div className="flex h-7 w-7 items-center justify-center rounded-full bg-text-primary text-white">2</div>
              <div className="flex flex-col">
                <Paragraph displayType="loud" colorType="primary">
                  Provide verification documents
                </Paragraph>
                <Paragraph colorType="primary">Share documentation that confirms you represent the clinic</Paragraph>
              </div>
            </div>

            <div className="flex flex-row gap-4">
              <div className="flex h-7 w-7 items-center justify-center rounded-full bg-text-primary text-white">3</div>
              <div className="flex flex-col">
                <Paragraph displayType="loud" colorType="primary">
                  Access approved
                </Paragraph>
                <Paragraph colorType="primary">
                  Once verified, you can view full lead details and manage your profile
                </Paragraph>
              </div>
            </div>

            <div className="flex flex-row gap-2 p-4 rounded-lg bg-blue-50">
              <EnvelopeIcon className="text-blue-800 size-6 shrink-0" />
              <Paragraph className="text-blue-800!">
                Stay connected: We'll send updates to your registered email address. Check your spam folder if you don't
                see our message.
              </Paragraph>
            </div>

            <div className="border"></div>

            <div className="flex flex-col gap-2">
              <Paragraph className="text-lg!" displayType="loud" colorType="primary">
                While you wait
              </Paragraph>
              <Paragraph colorType="primary">
                If you have any questions in the meantime, please contact our support
              </Paragraph>
              <Button
                text="Contact Support"
                appearance="secondary"
                onClick={() => {
                  navigate("/support");
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
